import { render, staticRenderFns } from "./BetgameTermsOfUse.vue?vue&type=template&id=70150da8&scoped=true"
import script from "./BetgameTermsOfUse.vue?vue&type=script&lang=js"
export * from "./BetgameTermsOfUse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70150da8",
  null
  
)

export default component.exports